module.exports = __webpack_public_path__ + "img/pijltje-dropdown.8671c42cfc1f937860d22e7d90e5fab8.svg";